import { Pipe, PipeTransform } from '@angular/core';
import { ServiceCarpetStainRemoval } from '../models/entities/service';

@Pipe({
  name: 'serviceCarpetStainRemovalName'
})
export class ServiceCarpetStainRemovalNamePipe implements PipeTransform {
  transform(type?: ServiceCarpetStainRemoval | ServiceCarpetStainRemoval[] | string | string[]): string | undefined {
    if (!type) {
      return;
    }

    if (Array.isArray(type)) {
      if (type.length <= 0) {
        return;
      }
      return type.map(t => this.getTypeName(t)).join(', ');
    } else {
      return this.getTypeName(type);
    }
  }

  private getTypeName(type: ServiceCarpetStainRemoval | string): string {
    switch (type) {
      case ServiceCarpetStainRemoval.driver:
      case 'Driver': {
        return 'Conducteur';
      }
      case ServiceCarpetStainRemoval.passenger:
      case 'Passenger': {
        return 'Passager';
      }
      case ServiceCarpetStainRemoval.back_left:
      case 'BackLeft': {
        return 'Arrière gauche';
      }
      case ServiceCarpetStainRemoval.back_right:
      case 'BackRight': {
        return 'Arrière droit';
      }
      case ServiceCarpetStainRemoval.boot:
      case 'Boot': {
        return 'Coffre';
      }
    }
    return type.toString();
  }
}
